import { useState, useEffect } from 'react';
import { blockedInsuranceService } from './blockedInsuranceService';

function useBlockedInsuranceHook() {
    const [blockedInsuranceState, setBlockedInsuranceState] = useState([]);





    const fetchBlockedInsurance = async () => {
        try {
            let result = await blockedInsuranceService();
            if (result.status === 200) setBlockedInsuranceState(result?.data?.result);
        } catch (e) {
            return e
        }

    }
    useEffect(() => {
        fetchBlockedInsurance();
    }, []);
    const handleGetRowId = (e) => {
        return e?.ipdid
      }
    return {
        blockedInsuranceState,
        setBlockedInsuranceState,
        handleGetRowId


    };
}

export default useBlockedInsuranceHook;
